import { GEOIP_SUCCESS } from "./geoip-action-types";

export default function geoipReducer(state = false, action) {
    if (action.type === GEOIP_SUCCESS) {
        return true;
    }
    return state;
}
